import type { CategoryContent } from '../row.js';

export const ROMANIAN_HISTORY: CategoryContent = {
  bscba: [
    [
      'Walachije en Moldavië waren middeleeuwse vorstendommen. Hun grondgebieden lagen voornamelijk in welke geografische regio?',
      [
        'Ten zuiden van de Karpaten, in Roemenië',
        'De Balkan ten oosten van Servië, ten westen van de Zwarte Zee',
        'De oostelijke Donaudelta en omliggende vlaktes',
        'Hedendaags Moldavië, ten noorden van Roemenië',
      ],
      0,
      'Walachije bezette veel van het zuiden van Roemenië; Moldavië lag ten noordoosten. Beide lagen ten zuiden en oosten van de Karpaten.',
    ],
    [
      'Gedurende het grootste deel van de middeleeuwse en vroegmoderne periode betaalden Walachije en Moldavië tribut aan welk imperium?',
      [
        'Het Osmaanse Rijk',
        'Het Oostenrijks-Hongaarse Keizerrijk',
        'Het Russische Rijk',
        'Het Byzantijnse Rijk',
      ],
      0,
      'Beide vorstendommen waren Ottomaanse vazallen van de 15e tot 19e eeuw en betaalden jaarlijkse tribut terwijl ze interne autonomie behielden.',
    ],
    [
      'In 1859 werden Walachije en Moldavië verenigd tot een enkele staat onder welke leider?',
      [
        'Alexander John Cuza',
        'Carol I van Hohenzollern',
        'Michael de Dappere',
        'Stefanus de Grote',
      ],
      0,
      'Cuza bewerkstelligde de eenwording van de twee vorstendommen en legde daarmee de basis voor het moderne Roemenië. Carol I werd de eerste gekozen vorst.',
    ],
    [
      'Roemeense onafhankelijkheid van het Osmaanse Rijk werd formeel erkend in welk jaar?',
      [
        '1877',
        '1859',
        '1878',
        '1869',
      ],
      0,
      'Roemenië verklaarde zich onafhankelijk in 1877 tijdens de Russisch-Turkse Oorlog; het Verdrag van Berlijn in 1878 bevestigde internationale erkenning.',
    ],
    [
      'Na de Eerste Wereldoorlog verkreeg Roemenië aanzienlijk grondgebied, waardoor "Groter Roemenië" ontstond. Welke belangrijke regio werd verworven?',
      [
        'Transsylvanië',
        'De Krim',
        'Galicië',
        'Bulgarije',
      ],
      0,
      'Transsylvanië (destijds deel van Oostenrijk-Hongarije) sloot zich in 1918 bij Roemenië aan. Boekovina en Bessarabië werden ook verworven, waardoor Roemenië\'s oppervlakte verdubbelde.',
    ],
    [
      'Aan welke alliantie sloot Roemenië zich aan gedurende de Eerste Wereldoorlog?',
      [
        'De Entente-mogendheden (Geallieerden)',
        'De Centrummogendheden (Duitsland, Oostenrijk-Hongarije)',
        'Bleef gedurende de hele oorlog neutraal',
        'Sloot zich laat aan bij het Osmaanse Rijk',
      ],
      0,
      'Roemenië trad in 1916 toe tot de Eerste Wereldoorlog aan de zijde van de Geallieerden, in de hoop Transsylvanië en ander Oostenrijks-Hongaars grondgebied te verkrijgen.',
    ],
    [
      'Gedurende de Tweede Wereldoorlog sloot Roemenië zich aanvankelijk aan bij welke natie?',
      [
        'Nazi-Duitsland',
        'De Sovjet-Unie',
        'Het Verenigd Koninkrijk',
        'De Verenigde Staten',
      ],
      0,
      'Roemenië onder generaal Antonescu sloot zich in 1941 aan bij de Asmogendheden, hoewel het in 1944 van zijde wisselde toen Sovjet-troepen oprukten.',
    ],
    [
      'De Roemeense communistische machtsovername vond plaats in ongeveer welk jaar?',
      [
        '1947',
        '1944',
        '1945',
        '1948',
      ],
      0,
      'De Volksrepubliek Roemenië werd in december 1947 uitgeroepen, waarmee de door de Sovjet-Unie gesteunde communistische controle werd bevestigd.',
    ],
    [
      'Nicolae Ceaușescu was Roemenië\'s communistische leider gedurende ongeveer hoeveel jaar?',
      [
        '24 jaar (1965–1989)',
        '15 jaar (1970–1985)',
        '30 jaar (1955–1985)',
        '10 jaar (1975–1985)',
      ],
      0,
      'Ceaușescu leidde Roemenië van 1965 tot zijn executie in december 1989, waardoor hij een van de langst regerende communistische leiders werd.',
    ],
    [
      'De val van het communisme in Roemenië werd gekenmerkt door een revolutie in welk jaar?',
      [
        '1989',
        '1988',
        '1990',
        '1991',
      ],
      0,
      'De Roemeense Revolutie vond plaats in december 1989 en culmineerde met Ceaușescu\'s executie op 25 december.',
    ],
    [
      'Transsylvanië, een regio met een grote etnische Hongaarse bevolking, maakte deel uit van welk imperium voordat het in 1918 bij Roemenië aansloot?',
      [
        'Het Oostenrijks-Hongaarse Keizerrijk',
        'Het Osmaanse Rijk',
        'Het Russische Rijk',
        'Onafhankelijke koninkrijken en vorstendommen',
      ],
      0,
      'Oostenrijk-Hongarije behield Transsylvanië tot 1918. Het werd onderdeel van Groter Roemenië na de Eerste Wereldoorlog.',
    ],
    [
      'Stefanus de Grote was een beroemde middeleeuwse heerser van welk vorstenddom?',
      [
        'Moldavië',
        'Walachije',
        'Transsylvanië',
        'Dobruja',
      ],
      0,
      'Stefanus (heerste 1457–1504) was Moldavië\'s grootste koning, die tegen Ottomaanse expansie weerstand bood en culturele prestaties behaalde.',
    ],
    [
      'Vlad III, bekend als "Vlad de Punter", heerste over welk vorstendom in de 15de eeuw?',
      [
        'Walachije',
        'Moldavië',
        'Transsylvanië',
        'Servië',
      ],
      0,
      'Vlad III (ca. 1431–1476) heerste over Walachije. Hij werd berucht om zijn wrede bestraffingen, wat gedeeltelijk de Dracula-mythologie inspireerde.',
    ],
    [
      'In welke periode verenigde Michael de Dappere kortstondig alle drie de Roemeense territoria (Walachije, Moldavië en Transsylvanië)?',
      [
        '1594–1595',
        '1475–1476',
        '1520–1525',
        '1600–1605',
      ],
      0,
      'Michael de Dappere (Mihai Viteazul) bereikte een tijdelijke eenwording van de drie regio\'s in 1594–1595, een belangrijke vroege mijlpaal.',
    ],
    [
      'Nadat het Osmaanse Rijk afnam, welke Europese mogendheid oefende in de 19de eeuw de sterkste politieke invloed op Roemenië uit?',
      [
        'Het Russische Rijk',
        'Oostenrijk-Hongarije',
        'Frankrijk',
        'Pruisen',
      ],
      0,
      'Ruslands nabijheid en militaire sterkte maakten het de dominante externe invloed, hoewel Oostenrijk-Hongarije ook significant was.',
    ],
  ],
  msc: [
    [
      'De Fanarioten waren een klasse van heersers die meer dan een eeuw over Walachije en Moldavië werden opgelegd. Uit welke groep werden zij gerekruteerd?',
      [
        'Griekse functionarissen en kooplieden aangesteld door de Ottomaanse sultans',
        'Lokale boyaradel bevorderd door Ottomaanse gouverneurs',
        'Roemeense kooplieden die samenwerkten met Ottomaanse autoriteiten',
        'Europese diplomaten gestuurd door rivaliserende imperia om Ottomaans grondgebied te besturen',
      ],
      0,
      'Fanarioten waren Griekssprekende Ottomaanse functionarissen, genoemd naar de Fanarwijk in Constantinopel. Zij heersten over Walachije en Moldavië (1711–1821).',
    ],
    [
      'De Organieke Regelingen van 1831–1834 stelden grondwettelijke kaders in Walachije en Moldavië in. Onder welke externe mogendheid werden zij ingevoerd?',
      [
        'Het Russische Rijk',
        'De Ottomaanse sultans rechtstreeks',
        'Oostenrijkse diplomatieke druk van Hongarije',
        'Britse en Franse koloniale administratie',
      ],
      0,
      'Rusland legde de Organieke Regelingen op als Ottomaanse opperheer en creëerde aldus gekozen vergaderingen en moderne administratieve structuren.',
    ],
    [
      'In de Russisch-Turkse Oorlog van 1877–1878 kreeg Roemenië onafhankelijkheid, maar moest welk grondgebied aan Rusland afstaan?',
      [
        'Zuid-Bessarabië',
        'Transsylvanië volledig',
        'De hele westgrens van Walachije',
        'De Donaudelta',
      ],
      0,
      'Roemenië werd gedwongen Zuid-Bessarabië aan Rusland af te staan als prijs voor Russische militaire steun en Ottomaanse erkenning van onafhankelijkheid.',
    ],
    [
      'Ion C. Brătianu was een dominante politieke figuur in Roemenië tijdens het einde van de 19e en het begin van de 20e eeuw. Welke partij leidde hij?',
      [
        'De Nationaal-Liberale Partij',
        'De Conservatieve Partij',
        'De Nationale Boerenpartij',
        'De Sociaaldemocratische Partij',
      ],
      0,
      'Brătianu was de leidende figuur van de Nationaal-Liberale Partij, die industrialisatie, landhervormingen en agrarische expansie bevorderde.',
    ],
    [
      'In de interbellumperiode (1918–1940) probeerde Roemenië landhervorming door te voeren. Welke sociale groep was het primaire doel van onteigening?',
      [
        'De grote landgoederen van de oude adel',
        'Stedelijke handelaren en fabrikantseigenaren',
        'Orthodoxe kerkbezittingen',
        'Bedrijven in Joodse handen in de steden',
      ],
      0,
      'Landhervorming onteigende veel van de grote adellijke landgoederen en herverdeelde deze onder de boeren, hoewel de uitvoering traag verliep.',
    ],
    [
      'Koning Carol II verklaarde zichzelf op controversiële wijze dictator van Roemenië in welk jaar?',
      [
        '1938',
        '1933',
        '1936',
        '1935',
      ],
      0,
      'Carol II vestigde in 1938 een persoonlijk bewind, waarbij hij het parlement en de politieke partijen marginaliseerde terwijl het Europese autoritarisme opkwam.',
    ],
    [
      'Generaal Ion Antonescu nam de macht in Roemenië in 1940 over en leidde het gedurende de Tweede Wereldoorlog onder welke titel?',
      [
        'Conducător (gelijk aan "Führer" of "Duce")',
        'Regent voor de afwezige Koning Michael',
        'Eerste Minister onder koninklijke autoriteit',
        'Tijdelijke militaire beheerder',
      ],
      0,
      'Antonescu droeg de titel "Conducător" en regeerde als militaire dictator. Hij bracht Roemenië in lijn met Nazi-Duitsland.',
    ],
    [
      'De IJzeren Garde (Legioen van de Aartsengel Michael) was een fascistische beweging in Roemenië. Haar leider was welke figuur?',
      [
        'Corneliu Codreanu',
        'Ion Antonescu',
        'Carol I',
        'Nicolae Ceaușescu',
      ],
      0,
      'Codreanu richtte en leidde de IJzeren Garde (1927–1938) tot zijn arrestatie en moord tijdens communistische zuiveringen.',
    ],
    [
      'Roemenië wisselde in augustus 1944 van de kant van de As naar de Geallieerden, vooral vanwege welke militaire ontwikkeling?',
      [
        'De snelle Sovjet-opmars',
        'Duitse militaire ineenstorting in het westen',
        'Britse maritieme druk op de Zwarte Zee',
        'Amerikaanse luchtoverheersing',
      ],
      0,
      'Sovjet-troepen overschreden Roemenië\'s grens, wat koning Michaels staatsgreep tegen Antonescu en een onmiddellijke oorlogsverklaring aan Duitsland veroorzaakte.',
    ],
    [
      'Roemenië\'s territoria ten oosten van de rivier de Prut (Zuid-Bessarabië) werden in welk jaar door de Sovjet-Unie geannexeerd?',
      [
        '1940',
        '1918',
        '1945',
        '1950',
      ],
      0,
      'Sovjet-troepen bezetten Bessarabië in 1940; het gebied bleef na de Tweede Wereldoorlog onder Sovjetcontrole (later de Moldavische SSR), een bron van Roemeense wrok.',
    ],
    [
      'Nicolae Ceaușescu bevorderde een leer van onafhankelijkheid van Sovjet-controle terwijl hij nominaal communistisch bleef. Wat was dit beleid genoemd?',
      [
        '"Nationaal communisme"',
        '"Balkaanse bevrijdingsbeweging"',
        '"Donaufederatie"',
        '"Socialistisch patriottisme"',
      ],
      0,
      'Ceaușescu voerde een nationalistisch communisme en trotseerde de Sovjet-orthodoxie op kwesties als de Tsjechische invasie van 1968 en het buitenlands beleid.',
    ],
    [
      'Ceaușescu\'s "Systematisering" programma van de jaren 1970–1980 beoogde vooral welke transformatie?',
      [
        'Gedwongen plattelandshervestiging',
        'Industriële expansie en arbeidersherlocatie',
        'Groei lidmaatschap Communistische Partij',
        'Herbebossing en milieurestauratie',
      ],
      0,
      'Systematisering sloopte plattelandsdorpen en verhuisde boeren naar stedelijke agro-industriële complexen. Dit vernietigde traditionele gemeenschappen.',
    ],
    [
      'Ceaușescu\'s "Decembertese" van 1989 was zijn reactie op onrust in Timișoara. Wat riep zij expliciet op?',
      [
        'Onderdrukking van "hooligans"',
        'Democratische hervormingen en pluralisme',
        'Militaire inmenging van de Sovjet-Unie',
        'Economische privatisering',
      ],
      0,
      'De Decembertese beschuldigde buitenlandse agenten van de opstand en eiste harde onderdrukking. Dit voorspelde de uiteindelijke ineenstorting van het regime.',
    ],
    [
      'Nicolae Ceaușescu en zijn vrouw Elena werden op 25 december 1989 geëxecuteerd. Wie voerde de executie uit?',
      [
        'Een militair vuurpeloton',
        'Het Rode Leger van de Sovjet-Unie',
        'Een lynchmob uit de menigte in Boekarest',
        'De Securitate geheime politie',
      ],
      0,
      'Een militair tribunaal veroordeelde beiden ter dood wegens genocide; een vuurpeloton executeerde hen dezelfde dag. Dit maakte een einde aan hun 24-jarige bewind.',
    ],
    [
      'De Roemeense Revolutie van 1989 begon in welke stad, met onrust die zich naar Boekarest uitbreidde?',
      [
        'Timișoara',
        'Iași',
        'Cluj',
        'Constanța',
      ],
      0,
      'Timișoara-protesten in december 1989 ontketenden de bredere revolutie die Ceaușescu\'s regime binnen dagen omverwierp.',
    ],
  ],
  phd: [
    [
      'De boyarenklasse in middeleeuwse Walachije en Moldavië had een sociale positie tussen het vorstenhof en boerendom. Welke economische machtsbasis ondersteunde hun invloed?',
      [
        'Grote landbouwgoederen en lokale handelsmonopolies',
        'Eigenaarschap van textielbedrijven en stedelijke koopliedengilden',
        'Militaire leiding van stedelijke garnizoensforten',
        'Kerkelijke autoriteit over kloosters en Orthodoxe kerken',
      ],
      0,
      'Walachijnse en Moldavische boyaren waren erfelijke landeigenaren wier rijkdom afkomstig was van latifundia en lokale handelsprivileges.',
    ],
    [
      'De Organieke Regelingen van 1831–1834 stelden kiesvergaderingen in Walachije en Moldavië in. Welke klasse werd expliciet uitgesloten van stemrecht?',
      [
        'Boeren, Joden en de stedelijke armen',
        'Alleen vrouwen en kinderen',
        'Buitenlanders en Orthodoxe priesters',
        'Militaire officieren en burgerambtenaren',
      ],
      0,
      'Stemrecht was beperkt tot boyaren, rijke kooplieden en een deel van de geestelijkheid, waarbij de plattelands- en stadsbevolking werd uitgesloten.',
    ],
    [
      'Cuza\'s landhervormingen van 1864 in de nieuwe verenigde staat (Roemenië) raakten welk aandeel van bebouwbare grond?',
      [
        'Ongeveer 25%, van Kerkgrond',
        '50% van alle particuliere eigendommen',
        'Meer dan 75% van de Donau-overstromingsvlakte',
        'Bijna 100% van bosreserves',
      ],
      0,
      'De hervorming van 1864 herverdeelde kerk- en kloosterlanden (ongeveer een kwart van de bebouwbare grond) onder de boeren, zonder de landgoederen van de adel aan te raken.',
    ],
    [
      'Het Verdrag van Berlijn (1878) verplichtte Roemenië burgerrechten te verlenen aan alle inwoners, ongeacht religie. De status van welke minderheid werd een betwiste politieke kwestie?',
      [
        'Joden',
        'Moslims in grensregio\'s',
        'Katholieken in Transsylvanië',
        'Evangelische Duitsers in Banat',
      ],
      0,
      'Roemeense Joodse emancipatie (1878) werd formeel opgelegd, maar ondervond binnenlandse weerstand; antisemitische beperkingen bleven bestaan tot de Tweede Wereldoorlog.',
    ],
    [
      'Roemenië\'s industrialisering onder Carol I (1881–1914) concentreerde zich zwaar in welke sector?',
      [
        'Aardoliewinning en -raffinering',
        'Textielfabricage in Walachije',
        'Koolmijnbouw in Transsylvanië',
        'Graanmaling en agrarische verwerking',
      ],
      0,
      'Roemeense olieproductie werd tegen 1900 de op een na grootste van Europa; buitenlands (vooral Brits en Nederlands) kapitaal domineerde de industrie.',
    ],
    [
      'De Nationale Boerenpartij, opgericht in 1926, vertegenwoordigde een onderscheidende ideologie die welke elementen combineerde?',
      [
        'Agrarisch populisme en Orthodox nationalisme',
        'Marxistische klassentheorie met boerencöperatieve structuren',
        'Liberaal kapitalisme met vrijhandeluniversalisme',
        'Syndicalistische arbeidersorganisatie en stedelijk socialisme',
      ],
      0,
      'De Nationale Boerenpartij idealiseerde de boer als Roemenië\'s morele kern, verzette zich tegen industrialisering en verwierp zowel liberalisme als communisme.',
    ],
    [
      'De Codreanu-geleide Legioen van de Aartsengel Michael mengde fascisme met welk religieus en cultureel element specifiek voor Roemenië?',
      [
        'Orthodoxe offercultus',
        'Islamitische Soefitradities',
        'Protestantse evangelische theologie',
        'Pre-Christelijke heidense heropleving',
      ],
      0,
      'De ideologie van het Legioen mengde fascistisch ultranationalisme met Orthodox mysticisme; Codreanu\'s executie creëerde een martelaarscultus.',
    ],
    [
      'Gedurende de Fanariotenperiode (1711–1821) dienden de Moldavische en Wallachijnse vorstendommen welke administratieve functie binnen het Ottomaanse systeem?',
      [
        'Bufferstaten die tribut en militaire troepen leverden',
        'Volledig geïntegreerde provincies onder rechtstreekse Ottomaanse militaire regering',
        'Autonome stadstaten met volledige zelfbestuur',
        'Leen van Ottomaanse militaire elite (Timars)',
      ],
      0,
      'Het Ottomaanse systeem delegeerde het bestuur aan Fanarioten-gouverneurs en behield rechtstreekse controle voor strategische momenten, om winst te maximaliseren en kosten te minimaliseren.',
    ],
    [
      'De staatsgreep van Koning Michael in 1944 resulteerde in welke onmiddellijke geopolitieke gevolgen?',
      [
        'Roemenië wisselde van zijde, maar Sovjet-troepen bezetten het meteen',
        'Duitsland trok zich vrijwillig terug; Roemenië behield onafhankelijkheid',
        'Een Sovjet-satelliestaat werd formeel opgericht met verkiezingen',
        'NAVO-troepen bereikten Roemenië voor Sovjet-bezetting',
      ],
      0,
      'Michaels coup was symbolisch significant maar strategisch hol: Sovjet-troepen rukten al op en bezetting volgde onmiddellijk.',
    ],
    [
      'Roemeense communisten, die in 1944 minder dan 1.000 leden telden, consolideerden macht via welk mechanisme?',
      [
        'Sovjet-bezetting en een poppenregering',
        'Populaire verkiezing en massale rekrutering',
        'Burgeroorlog en gewapende revolutionair worsteling',
        'Onderhandelde coalitiebering met niet-communistische partijen',
      ],
      0,
      'De Roemeense Communistische Partij miste volkssteun; Sovjet-bajonetten installeerden hen aan de macht. Partijlidmaatschap groeide via dwang en prikkels.',
    ],
    [
      'Ceaușescu\'s reactie van 1968 op de Tsjechische invasie was uniek onder Warschaupactlanden. Wat deed hij?',
      [
        'Veroordeelde de Sovjet-inmenging publiekelijk als illegaal',
        'Ingezette troepen naast Sovjet-troepen Tsjech weerstand te onderdrukken',
        'Bleef geheel neutraal en stil',
        'Onderhandelde in het geheim Roemeense neutraliteit tegen Sovjet tolerantie',
      ],
      0,
      'Ceaușescu\'s toespraak van augustus 1968, waarin hij zich tegen de invasie verzette, versterkte zijn legitimiteit in binnen- en buitenland en vergrootte zijn autonomie ten opzichte van Moskou.',
    ],
    [
      'De Securitate, Roemeense geheime politie, breidde zich het meest dramatisch uit onder het mandaat van welke leider?',
      [
        'Nicolae Ceaușescu',
        'Generaal Antonescu gedurende WWII',
        'Koning Carol II in de jaren 1930',
        'Ion Dej in de jaren 1950',
      ],
      0,
      'Onder Ceaușescu werd de Securitate een van de meest gevreesde geheime diensten van Oost-Europa, met een uitgebreid netwerk van informanten.',
    ],
    [
      'Ceaușescu\'s leer van "socialistische zelfbeheer" in fabrieken werd beïnvloed door het Titoïstische model van welk land?',
      [
        'Joegoslavische raden',
        'Het Sovjet kolchozesysteem',
        'Chinese communes',
        'Noord-Korea\'s juchesysteem',
      ],
      0,
      'Ceaușescu nam gedeeltelijk het model van Joegoslavisch arbeiderszelfbestuur over als alternatief voor de centrale planning van de Sovjet-Unie.',
    ],
    [
      'De Timișoara-opstand van december 1989 begon als protest tegen welk onmiddellijk katalysator?',
      [
        'Deportatie van priester Tőkés',
        'Voedselrantsoenering en broodtekorten',
        'Militaire inmenging van de Sovjet-Unie',
        'Een loonsverlaging in een fabriek',
      ],
      0,
      'Tőkés, een etnisch Hongaarse priester, werd met deportatie bedreigd. Het verzet daartegen verenigde Timișoara: etnische Roemenen en Hongaren keerden zich gezamenlijk tegen het regime.',
    ],
    [
      'Het Roemeense lustratieproces en de overgangsrechtelijke procedures na 1989 verschilden op welk essentieel punt van die van Centraal-Europese buurlanden?',
      [
        'Roemenië voerde minimale decommunisatie door',
        'Roemenië voerde de grondige Securitate-processen in de regio uit',
        'Roemeense rechtbanken vervolgden onmiddellijk alle communistische leiders',
        'Roemenië ontbond geheel zijn militair en herbouwde van nul',
      ],
      0,
      'In tegenstelling tot Polen of Tsjechoslowakije zuiverde postcommunistisch Roemenië niet systematisch de bureaucratie; continuïteit won het van afrekening met het verleden.',
    ],
  ],
  professor: [
    [
      'De 14e-eeuwse oprichting van Walachije en Moldavië als afzonderlijke politieke entiteiten vloeide voort uit welke bredere geopolitieke fragmentatie?',
      [
        'Ineenstorting van Hongaars en Mongools opperheerschap',
        'Ottomaanse verovering en opzettelijke onderverdeling van veroverde territoria',
        'Pauselijke autoriteit fragmenterend regio in kerkelijke jurisdicties',
        'Byzantijnse keizerlijke provincies opgedeeld door successiedisputen',
      ],
      0,
      'Beide vorstendommen ontstonden als onafhankelijke staten in het vacuüm dat ontstond door de afname van de Hongaarse opperheerschappij en de Mongoolse suzereiniteit.',
    ],
    [
      'Boyarenopstanden en vorstelijke instabiliteit in Moldavië (15e–16e eeuwen) werden fundamenteel veroorzaakt door welke structurele spanning?',
      [
        'Boyaren-vorsten strijd om handel en belasting',
        'Religieuze scheuring tussen katholicisme en orthodoxie',
        'Geschillen over puur ceremoniële prerogatieven aan het hof',
        'Arbeidstekort in zoutmijnen en landbouwproductie',
      ],
      0,
      'Moldavische instabiliteit weerspiegelde het nulsomconflict tussen de inkomstenbehoeften van de vorst en de welvaartsconcentratie bij de boyaren; de Ottomaanse tribuutplicht zette beide onder druk.',
    ],
    [
      'De Russisch-Turkse Overeenkomst van 1774 (Verdrag van Küçük Kaynarca) verleende Rusland welk voorrecht met betrekking tot Walachije en Moldavië?',
      [
        'Een vaag "beschermingsrecht" over Ottomaanse christenen',
        'Rechtstreekse grondgebiedannexatie van beide vorstendommen',
        'Controle over Ottomaans buitenlands beleid naar Roemenië',
        'Exclusief handelsmonopolie in de Donaudelta',
      ],
      0,
      'Artikel 14 van het Verdrag van Küçük Kaynarca gaf Rusland een vage "beschermer"-status; Rusland gebruikte deze dubbelzinnigheid om een eeuw lang inmenging te rechtvaardigen.',
    ],
    [
      'Cuza\'s landhervormingen van 1864 sloten grote boyarengoederen opzettelijk uit, terwijl ze kerklanden herverdeelden. Welke fiscale logica rechtvaardigde dit compromis?',
      [
        'Kerkgrond was politiek veiliger te nemen',
        'Boyarenbezit was economisch onproductief en niet waard belasting',
        'Internationale verdragen verboden particuliere eigendomconfiscatie',
        'De Kerk offerde haar bezit op als patriottische bijdrage',
      ],
      0,
      'Cuza ondervond conservatieve weerstand; confiscatie van boyarengoederen riskeerde burgeronrust. Kerkconfiscatie was politiek haalbaar zonder de elite te bedreigen.',
    ],
    [
      'Roemenië\'s aardolie-industrie, door buitenlands kapitaal tot de jaren 1930 gedomineerd, creëerde welke structurele economische afhankelijkheid?',
      [
        'Zware afhankelijkheid van buitenlandse exportinkomsten',
        'Een arbeidsoverschot dat loondeflatie afdwong',
        'Technologische autarkie en isolatie van Europese markten',
        'Buitensporige staatscontrole die particuliere ondernemingen onderdrukte',
      ],
      0,
      'Britse, Nederlandse en Duitse oliebedrijven exploiteerden de Roemeense ruwe olie; de winsten vloeiden naar het buitenland, wat het kapitaal voor binnenlandse industrialisatie beperkte.',
    ],
    [
      'De Roemeense Grondwet van 1923 stelde universeel mannelijk kiesrecht in, maar behield welk mechanisme dat de democratische verantwoording beperkte?',
      [
        'Koninklijke decreetmacht en het recht parlement te ontbinden',
        'Een tweekamerig wetgevend orgaan met gelijk vetorecht over alle wetsvoorstellen',
        'Militair toezicht op alle wetgevingszittingen',
        'Kerkelijk vetorecht over seculiere wet',
      ],
      0,
      'De Grondwet van 1923 was liberaal van vorm, maar verleende de Kroon ruime uitvoerende bevoegdheden, wat een koninklijke dictatuur mogelijk maakte (gerealiseerd in 1938).',
    ],
    [
      'De ideologie van het Legioen van de Aartsengel Michael synthetiseerde fascisme met welk theologisch concept dat inherent is aan de Oosters-Orthodoxie?',
      [
        'Lijden en martelaarschap',
        'Pauselijke onfeilbaarheid vorderingen',
        'Calvinistische voorbestemming',
        'Soefische mystieke verrukking',
      ],
      0,
      'Het ethos van het Legioen mengde fascistisch ultranationalisme met Orthodox offermysticisme; Codreanu\'s moord maakte van hem een quasi-heilige.',
    ],
    [
      'De Molotov-Ribbentrop Geheime Protocollen van augustus 1939 wezen Roemenië toe aan de invloedssfeer van welke macht?',
      [
        'Impliciet Sovjet',
        'Duitslands exclusieve sfeer',
        'Italië\'s Mediterrane domein',
        'Bleef onder Volkenbondsnetraaliteitsbepalingen',
      ],
      0,
      'De protocollen bevatten geheime clausules die Sovjet-hegemoniale aanspraken op Bessarabië erkenden; Duitsland respecteerde deze en liet daarmee zijn eigen aanspraken varen.',
    ],
    [
      'Roemenië\'s grondgebiedverlies (Bessarabië, Noord-Boekovina, Zuid-Dobruja) tussen 1940–1945 volgde uit welke geopolitieke mechanismen?',
      [
        'Sovjet-opmars en Duitse onverschilligheid tegenover Roemenië',
        'Zuiver vrijwillige Roemeense cessies in onderhandelde verdragen',
        'Ottomaanse vorderingen hergesteld na Duitse bezetting',
        'Herverdeling opgelegd door de Volkenbond als straf',
      ],
      0,
      'De Sovjet-verwerving van Bessarabië (1940) en Noord-Boekovina verliep eenzijdig; de Bulgaarse verwerving van Zuid-Dobruja (1940) was onderhandeld. De nazi\'s steunden beide.',
    ],
    [
      'De periode 1948–1952 zag Roemeense Stalinistische leiding (Gheorghiu-Dej) massale industrialisering via welk mechanisme?',
      [
        'Gedwongen collectivisatie en graanconfiscatie',
        'Vrijwillige reorganisatie van landbouwcoöperaties',
        'Massale Westerse leningen en technologieoverdracht',
        'Herintegratie van particuliere ondernemingen van vóór 1940',
      ],
      0,
      'Dejs vroege Stalinistische fase vernietigde de boereneconomie via collectivisatie en brute graanextractie. Dit financierde industrialisatie volgens het Sovjetmodel.',
    ],
    [
      'Ceaușescu\'s "onafhankelijkheid binnen de bloc" vereiste welke precondities intern?',
      [
        'Partijeenheid en nationalistische ideologie',
        'Militaire alliantie met niet-gebonden naties',
        'Economische integratie met West-Europa',
        'Concurrentie tussen partijen in een meerpartijendemocratie',
      ],
      0,
      'Ceaușescu bevorderde nationalisme en een persoonlijkheidscultus om de samenhang van het regime te handhaven zonder Sovjetsteun. Dit maakte manoeuvreerruimte in het buitenlands beleid mogelijk.',
    ],
    [
      'De augustus 1968 Praagse Lente en Sovjet-invasie leidde Ceaușescu om civiele verdedigingskrachten te mobiliseren. Wat was de geopolitieke gok?',
      [
        'De gok dat nationalistisch vuur een Sovjet-aanval zou afschrikken',
        'De hoop dat de NAVO militair zou ingrijpen',
        'Verzoeken om Joegoslavische militaire bijstand',
        'Dreigen met nucleaire vergelding',
      ],
      0,
      'Ceaușescu\'s toespraak van 21 augustus, waarin hij zich tegen de invasie verzette, riskeerde de woede van de Sovjet-Unie, maar verdiepte zijn nationalistische legitimiteit in binnen- en buitenland.',
    ],
    [
      'Ceaușescu\'s "Systematisering" programma werd ideologisch gerechtvaardigd als bereiken welke socialistische doelstelling?',
      [
        'Eliminatie van de "achterlijkheid" van boeren via gedwongen urbanisatie',
        'Restaurering traditioneel dorpsleven',
        'Privatisering agrarische grond naar individuele boeren',
        'Versterking van de defensie-infrastructuur van de NAVO',
      ],
      0,
      'Systematisering werd gerechtvaardigd met het Stalinistische begrip van het uitbannen van "plattelandsobscurantisme"; in werkelijkheid ging het om hulpbronnenextractie en demografische controle.',
    ],
    [
      'De Roemeense buitenlandse schuldencrisis en bezuinigingsmaatregelen na 1970 (de "Gouden Eeuwen") volgden uit welke eerdere beleidsbesluiten?',
      [
        'Zware leningen voor prestigieuze industriële projecten',
        'Handelsembargo\'s door NAVO-landen opgelegd',
        'De Sovjet-Unie die goedkope goederen op Roemeense markten dumpte',
        'Opzettelijke IMF-austeriteitsvoorwaarden',
      ],
      0,
      'Ceaușescu\'s monumentale industrialisatieprojecten (staalwalserijen, het kanaal) verbruikten buitenlands krediet, maar leverden inefficiënte verliesbedrijven op.',
    ],
    [
      'De "Timișoara"-fase (15–21 dec) van de Roemeense revolutie van 1989 en de escalatie naar de "Boekarest"-fase (22–25 dec) omvatten welke kernovergang?',
      [
        'Lokaal protest werd landelijke opstand toen het leger overliep',
        'Verschuiving van vreedzaam protest naar gewapende gewelddadige opstand',
        'Aankomst NAVO vredeshandhavingskrachten',
        'Militaire inmenging van de Sovjet-Unie',
      ],
      0,
      'De onrust in Timișoara (15–21 december) verspreidde zich landelijk; toen legereenheden op 21–22 december overliepen, verdampte Ceaușescu\'s macht. Dit culmineerde in zijn proces en executie op 25 december.',
    ],
  ],
};
